<div class="search-area" [class.light]="light">
  <div class="search">
    <i class="icon icon-search"></i>
    <input
      [autocomplete]="false"
      type="text"
      class="input"
      [formControl]="searchControl"
      name="search"
      placeholder="Search for a Coin, Token here..."
      i18n-placeholder="@@serch.placeholder">
  </div>
</div>
